export interface IProjectShort {
  id: number
  projectName: string
}

export class IProjectShortClass {
  id: number = 0
  projectName: string = ''
}
